import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-361d3943"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pc-wrap"
}
const _hoisted_2 = {
  key: 1,
  class: "phone-wrap"
}

import { onMounted, defineAsyncComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStoreHook } from "@/store/modules/user";
import checkPc from "@/utils/checkPc";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const userStore = useUserStoreHook()
const { userInfo } = storeToRefs(userStore)

// 定义组件
const Layout = defineAsyncComponent(() => import('@/layout/index.vue'));
const JoinPc = defineAsyncComponent(() => import('./components/JoinPc.vue'));
const JoinPhone = defineAsyncComponent(() => import('./components/JoinPhone.vue'));

const isPC = checkPc()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Layout), {
    footer: false,
    parent: false
  }, {
    default: _withCtx(() => [
      (_unref(isPC))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(JoinPc), { userInfo: _unref(userInfo) }, null, 8, ["userInfo"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(JoinPhone), { userInfo: _unref(userInfo) }, null, 8, ["userInfo"])
          ]))
    ]),
    _: 1
  }))
}
}

})